/**
 * Football Terms Pack - American Football/NFL vocabulary
 * NFL team names (without cities) and game-related terminology
 */

import { WordPack } from '../../types/GameTypes';

const footballTermsPack: WordPack = {
  id: 'football-terms',
  name: 'Football Terms',
  description: 'American Football and NFL vocabulary - team names, positions, plays, and game terminology',
  difficulty: 'medium',
  words: [
    // NFL Team Names (without city names)
    "COWBOYS", "PACKERS", "STEELERS", "PATRIOTS", "RAIDERS", "EAGLES",
    "GIANTS", "BEARS", "LIONS", "VIKINGS", "SAINTS", "FALCONS",
    "PANTHERS", "BUCCANEERS", "CARDINALS", "SEAHAWKS", "RAMS", "NINERS",
    "CHIEFS", "BRONCOS", "CHARGERS", "BILLS", "DOLPHINS",
    "JETS", "RAVENS", "BENGALS", "BROWNS", "TITANS", "COLTS",
    "JAGUARS", "TEXANS", "COMMANDERS",
    
    // Positions - Offense
    "QUARTERBACK", "RUNNINGBACK", "FULLBACK", "HALFBACK", "TAILBACK",
    "WIDEOUT", "RECEIVER", "TIGHTEND", "CENTER", "GUARD", "LINEMAN",
    
    // Positions - Defense
    "LINEBACKER", "CORNERBACK", "SAFETYPOSITION", "NOSEGUARD", "NOSETACKLE",
    "RUSHER",
    
    // Positions - Special Teams
    "KICKER", "PUNTER", "HOLDER", "SNAPPER", "RETURNER", "GUNNER",
    
    // Plays & Actions - Offense
    "TOUCHDOWN", "FIELDGOAL", "EXTRAPOINT", "CONVERSION", "SCORE",
    "PASS", "RUSH", "BLOCKING", "SNAP", "HANDOFF", "PITCH",
    "LATERAL", "FORWARD", "SHOTGUN", "FORMATION", "MOTION", "SHIFT",
    "AUDIBLE", "HIKE", "DOWN", "FIRSTDOWN", "SECONDDOWN", "THIRDDOWN", "FOURTHDOWN",
    "DRIVE", "MARCH", "ADVANCE", "YARDAGE",
    "SCRAMBLE", "POCKET", "PROTECTION", "BLITZING", "SCREEN", "DRAW",
    "REVERSE", "SWEEP", "BOOTLEG", "ROLLOUT", "PLAYACTION", "OPTION",
    "WILDCAT", "TRICK", "GADGET", "HURRYUP", "SPIKE",
    
    // Plays & Actions - Defense
    "TACKLE", "SACK", "BLITZ", "COVERAGE", "ZONE", "PRESS",
    "INTERCEPT", "FUMBLE", "STRIP", "RECOVERY", "DEFLECTION",
    "DEFEND", "CONTAIN", "PURSUIT", "STUNTING", "PENETRATION",
    
    // Special Teams
    "KICKOFF", "PUNT", "ONSIDE", "SQUIB", "TOUCHBACK", "COFFINCORNER",
    "RETURN", "BLOCK", "FAKE",
    
    // Game Situations
    "REDZONE", "MIDFIELD", "ENDZONE", "SIDELINE", "BACKFIELD",
    "TRENCHES", "SECONDARY", "FRONTLINE", "HURDLE", "STIFFARM",
    "JUKING", "SPINNING", "CUTBACK", "BREAKING", "GAINING",
    
    // Penalties
    "HOLDING", "OFFSIDE", "ENCROACHMENT", "FALSESTART", "DELAYOFGAME",
    "ROUGHING", "FACEMASK", "CLIPPING", "INTERFERENCE", "TARGETING",
    "TAUNTING", "UNSPORTSMANLIKE", "ILLEGAL", "INELIGIBLE",
    
    // Game Structure
    "QUARTER", "HALFTIME", "OVERTIME", "SUDDENDEATH",
    "TIMEOUT", "CHALLENGE", "REVIEW", "REPLAY", "COINTOSS",
    "POSSESSION", "OFFENSE", "DEFENSE", "SPECIALTEAMS",
    
    // Scoring
    "POINTS", "SAFETY",
    
    // Field Elements
    "GRIDIRON", "TURF", "GRASS", "HASHMARKS", "GOALPOST",
    "PYLON", "CHAINS", "MARKER", "BENCH", "HUDDLE",
    
    // Equipment
    "HELMET", "FACEGUARD", "PADS", "CLEATS", "GLOVES",
    "JERSEY", "PANTS", "CHINSTRAP", "MOUTHGUARD",
    
    // Game Terms
    "ROSTER", "DEPTHCHART", "STARTER", "BACKUP", "PRACTICE",
    "SQUAD", "INJURED", "RESERVE", "ACTIVE", "INACTIVE",
    "DRAFT", "ROOKIE", "VETERAN", "CAPTAIN", "COACH",
    "COORDINATOR", "PLAYBOOK", "SCHEME", "STRATEGY", "GAMEPLAN",
    
    // Stats & Metrics
    "COMPLETION", "ATTEMPT", "QBRATING", "EFFICIENCY", "YARDLINE",
    "AVERAGE", "TOTAL", "RECEIVING",
    "INTERCEPTION", "TURNOVER",
    
    // Descriptors
    "OFFENSIVE", "DEFENSIVE", "MOMENTUM", "CLUTCH", "PRESSURE",
    "EXPLOSIVE", "ATHLETIC", "POWERFUL", "SPEED", "AGILITY",
    "STRENGTH", "ENDURANCE", "PRECISION", "TIMING", "EXECUTION",
    
    // Game Outcomes
    "VICTORY", "DEFEAT", "WINNING", "LOSING", "LEADING",
    "TRAILING", "COMEBACK", "UPSET", "SHUTOUT", "BLOWOUT",
    
    // Championships & Playoffs
    "SUPERBOWL", "PLAYOFFS", "WILDCARD", "DIVISIONAL", "CONFERENCE",
    "CHAMPIONSHIP", "TROPHY", "RING", "CHAMPION",
    
    // Fans & Atmosphere
    "CROWD", "FANS", "CHEER", "TAILGATE", "STADIUM", "ARENA",
    "HOMEFIELD",
    
    // Weather & Conditions
    "WEATHER", "ELEMENTS", "FROZEN", "MUDDY", "WINDY", "SNOWY"
  ]
};

export default footballTermsPack;
